import React from "react";
import { useState, useEffect, Fragment } from "react";
import AuthService from "../services/auth.service";
import api from "../services/api";
import { Link, useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import CalfMenuItem from "../components/CalfMenuItem";
import { Dialog, Transition } from "@headlessui/react";

function Home() {
  const navigate = useNavigate();
  const [listCalfs, setListCalfs] = useState([]);
  const [search, setSearch] = useState("");
  const [view, setView] = useState("");
  const [healthFilter, setHealthFilter] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [isDisplay, setDisplay] = useState(false);

  const getCalfs = async (userId) => {
    try {
      const response = await api.get("/calfs/user/" + userId);
      setListCalfs(response.data);
      setLoading(false);
    } catch (err) {
      console.error(err.message);
    }
  };
  const refreshCalfs = () => {
    const currentUser = AuthService.getCurrentUser();
    getCalfs(currentUser.id);
  };
  const handleClose = () => {
    setDisplay(!isDisplay);
  };
  const switchView = (view) => {
    setView(view);
    setHealthFilter(view);
  };
  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();
    if (!currentUser) {
      navigate("/login");
    } else {
      getCalfs(currentUser.id);
    }
  }, []);
  if (isLoading) {
    return <div></div>;
  }
  return (
    <div>
      <TopBar link=""></TopBar>
      <div className="md:flex md:flex-col md:items-center">
        <div className="md:w-[1400px] md:bg-white md:pb-3 dark:md:bg-slate-900">
          <div className={listCalfs.length === 0 ? "" : "hidden"}>
            <div className="mt-10 flex flex-col items-center justify-center">
              <img src="./empty_state.png" className="h-36 opacity-20 dark:opacity-10"></img>
              <div className=" my-3">
                <span className="font-semibold dark:text-white">
                  Commencez par ajouter un veau
                </span>
              </div>
              <div className="mb-3">
                <p className="text-center text-sm text-stone-600 dark:text-slate-300">
                  La liste de vos veaux s'affichera ici. Commencer par ajouter
                  un veau en cliquant sur "Ajouter un veau"
                </p>
              </div>
              <Link to="/nouveau">
                <button className="mt-3 rounded-lg bg-amber-400 px-3 py-2 text-sm text-white md:hidden dark:bg-amber-500 dark:hover:bg-amber-600">
                  Ajouter un veau
                </button>
              </Link>

              <button
                onClick={() => navigate("/nouveau")}
                className="mt-3 hidden rounded-lg bg-amber-400 px-3 py-2 text-sm text-white md:block dark:bg-amber-500 dark:hover:bg-amber-600"
              >
                Ajouter un veau
              </button>
            </div>
          </div>
          <div className={listCalfs.length === 0 ? "hidden" : ""}>
            <div className="my-3 flex flex-col">
              <div className="flex items-center justify-between px-3 md:mb-3 md:px-0">
                <span className="text-2xl font-bold dark:text-white">Mon troupeau</span>
                <div className="md:hidden">
                  <Link to="/nouveau">
                    <button className="mb-3 flex rounded-md border border-amber-500 bg-amber-400 px-3 py-2 text-sm text-white shadow transition-all duration-100 hover:shadow-inner dark:border-amber-500 dark:bg-amber-600 dark:hover:bg-amber-500">
                      Ajouter un veau
                    </button>
                  </Link>
                </div>
                <div className="hidden md:block">
                  <button
                    onClick={() => navigate("/nouveau")}
                    className="flex rounded-md border border-amber-500 bg-amber-400 px-3 py-2 text-sm text-white font-medium shadow transition-all duration-100 hover:shadow-inner dark:border-amber-500 dark:bg-amber-600 dark:hover:bg-amber-500"
                  >
                    Ajouter un veau
                  </button>
                </div>
              </div>
              <div className="mb-6 hidden w-full border-b border-stone-300 dark:border-slate-600 md:block"></div>
              <div className="flex">
                <div className="mt-12 hidden md:flex md:w-1/5 md:flex-col md:justify-start">
                  <button
                    className={
                      "flex w-fit rounded-lg px-3 py-2 " +
                      (view == "" ? "bg-amber-100 dark:bg-amber-900/30" : "")
                    }
                    onClick={() => switchView("")}
                  >
                    <div className="flex w-40">
                      <span
                        className={
                          view == ""
                            ? "font-semibold text-amber-800 dark:text-amber-300"
                            : "font-medium text-stone-500 dark:text-slate-300"
                        }
                      >
                        Tous les éléments
                      </span>
                    </div>
                    <div
                      className={
                        "ml-3 flex content-center items-center justify-center rounded-full  px-[10px] py-1 " +
                        (view == ""
                          ? "bg-amber-700 text-amber-200 dark:bg-amber-600 dark:text-amber-100"
                          : "bg-stone-100 text-stone-700 dark:bg-slate-700 dark:text-slate-300")
                      }
                    >
                      <span className="text-xs font-medium">
                        {listCalfs.length}
                      </span>
                    </div>
                  </button>
                  <button
                    className={
                      "flex w-fit rounded-lg px-3 py-2 " +
                      (view == "healthy" ? "bg-amber-100 dark:bg-amber-900/30" : "")
                    }
                    onClick={() => switchView("healthy")}
                  >
                    <div className="flex w-40">
                      <span
                        className={
                          view == "healthy"
                            ? "font-semibold text-amber-800 dark:text-amber-300"
                            : "font-medium text-stone-500 dark:text-slate-300"
                        }
                      >
                        En Bonne santé
                      </span>
                    </div>
                    <div
                      className={
                        "ml-3 flex content-center items-center justify-center rounded-full  px-[10px] py-1 " +
                        (view == "healthy"
                          ? "bg-amber-700 text-amber-200 dark:bg-amber-600 dark:text-amber-100"
                          : "bg-stone-100 text-stone-700 dark:bg-slate-700 dark:text-slate-300")
                      }
                    >
                      <span className="text-xs font-medium">
                        {
                          listCalfs.filter(function (item) {
                            return item.health_status
                              .toLowerCase()
                              .includes("healthy");
                          }).length
                        }
                      </span>
                    </div>
                  </button>
                  <button
                    className={
                      "flex w-fit rounded-lg px-3 py-2 " +
                      (view == "ill" ? "bg-amber-100 dark:bg-amber-900/30" : "")
                    }
                    onClick={() => switchView("ill")}
                  >
                    <div className="flex w-40">
                      <span
                        className={
                          view == "ill"
                            ? "font-semibold text-amber-800 dark:text-amber-300"
                            : "font-medium text-stone-500 dark:text-slate-300"
                        }
                      >
                        Malade
                      </span>
                    </div>
                    <div
                      className={
                        "ml-3 flex content-center items-center justify-center rounded-full  px-[10px] py-1 " +
                        (view == "ill"
                          ? "bg-amber-700 text-amber-200 dark:bg-amber-600 dark:text-amber-100"
                          : "bg-stone-100 text-stone-700 dark:bg-slate-700 dark:text-slate-300")
                      }
                    >
                      <span className="text-xs font-medium">
                        {
                          listCalfs.filter(function (item) {
                            return item.health_status
                              .toLowerCase()
                              .includes("ill");
                          }).length
                        }
                      </span>
                    </div>
                  </button>
                </div>
                <div className="flex w-full flex-col md:w-4/5">
                  <div className="flex flex-col px-3 md:px-0">
                    <input
                      className="w-full rounded-md border border-stone-300 px-3 py-2 md:w-64 md:self-end dark:bg-slate-800 dark:border-slate-600 dark:text-white"
                      placeholder="Chercher"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    ></input>
                  </div>
                  <div className="my-3 border-b border-stone-200 shadow md:rounded-lg md:border dark:border-slate-600">
                    <div className="flex border-y border-stone-300 bg-white  text-sm md:rounded-t-lg md:border-b md:border-t-0 md:bg-stone-50 md:py-3 dark:bg-slate-800 dark:border-slate-600 dark:text-white">
                      <div className="ml-3 w-44">
                        <span>Nom</span>
                      </div>
                      <div className="w-32">
                        <span>Status</span>
                      </div>
                    </div>
                    {listCalfs
                      .filter(function (item) {
                        return item.name.toLowerCase().includes(search);
                      })
                      .filter(function (item) {
                        return item.health_status
                          .toLowerCase()
                          .includes(healthFilter);
                      })
                      .map((item, index) => (
                        <Link
                          key={"link_" + item.pk_calf}
                          to={"/veaux/" + item.pk_calf}
                          state={{ from: "weights" }}
                        >
                          <CalfMenuItem
                            key={item.pk_calf}
                            props={{
                              calf: item,
                              index: index,
                              length: listCalfs.length,
                            }}
                          ></CalfMenuItem>
                        </Link>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
